import { call, put, takeLeading } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import duplicateCourseLesson from 'api/administration/courses/Duplicate'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'

async function handleDuplicateCourse(contentToDuplicate: any) {
  return await duplicateCourseLesson(contentToDuplicate)
}

function* duplicateCourseEffectSaga(action: any) {
  try {
    yield call(handleDuplicateCourse, action.payload)
    yield put(fromActions.Actions.courseAdministrationGetList({ page: 1, searchText: '', sort: [] }))
    SuccessToast(I18n.t('administration.toastMessages.courseDuplicatedSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.courseDuplicateError'))
    console.log('error: ', error)
  }
}

export function* duplicateCourseWatcherSaga() {
  yield takeLeading(fromActions.COURSE_DUPLICATE, duplicateCourseEffectSaga)
}
